export const DEFAULT_NEW_POSITION_SHIELD_PRESET = 'strength_3';

export const DEFAULT_NEW_POSITION_SHIELD_PRESET_OPTIONS = [
  { value: 'strength_3', label: 'Strength -3%' },
  { value: 'volatile_5', label: 'Volatile -5%' },
  { value: 'medium_6', label: 'Medium -6%' },
  { value: 'base_7', label: 'Base -7%' },
  { value: 'long_9', label: 'Long -9%' },
  { value: 'extended_10', label: 'Extended -10%' },
  { value: 'llong_12', label: 'LLong -12%' },
  { value: 'lllong_15', label: 'LLLong -15%' },
  { value: 'tight_2', label: 'Tight -2%' },
  { value: 'none', label: 'None' }
];

const PRESET_CONFIGS = {
  tight_2: { shield_name: 'Tight Play -2%', trailing_distance: 2 },
  strength_3: { shield_name: 'Strength Play -3%', trailing_distance: 3 },
  volatile_5: { shield_name: 'Volatile Play -5%', trailing_distance: 5 },
  medium_6: { shield_name: 'Medium Play -6%', trailing_distance: 6 },
  base_7: { shield_name: 'Base Play -7%', trailing_distance: 7 },
  long_9: { shield_name: 'Long Play -9%', trailing_distance: 9 },
  extended_10: { shield_name: 'Extended Play -10%', trailing_distance: 10 },
  llong_12: { shield_name: 'LLong Play -12%', trailing_distance: 12 },
  lllong_15: { shield_name: 'LLLong Play -15%', trailing_distance: 15 }
};

export const normalizeDefaultNewPositionShieldPreset = (preset) => {
  if (!preset) {
    return DEFAULT_NEW_POSITION_SHIELD_PRESET;
  }

  return DEFAULT_NEW_POSITION_SHIELD_PRESET_OPTIONS.some((option) => option.value === preset)
    ? preset
    : DEFAULT_NEW_POSITION_SHIELD_PRESET;
};

export const buildDefaultNewPositionShieldPayload = (preset, { shares, basePrice }) => {
  const normalizedPreset = normalizeDefaultNewPositionShieldPreset(preset);

  if (normalizedPreset === 'none') {
    return null;
  }

  const presetConfig = PRESET_CONFIGS[normalizedPreset];
  if (!presetConfig) {
    return null;
  }

  return {
    shield_name: presetConfig.shield_name,
    shield_type: 'TRAILING_STOP',
    shield_percentage: String(shares),
    is_active: true,
    shield_price: basePrice,
    trailing_distance: presetConfig.trailing_distance,
    trailing_distance_type: 'PERCENTAGE'
  };
};
